import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["PhaseSection","PhaseSectionTitle","PhaseSectionDescription","PhaseSectionStatsBox"] */ "/app/src/components/new/PhaseSection/PhaseSection.tsx");
